import React, { useState } from "react";
import { styled } from "@mui/material";

import { DataGridPro } from "@mui/x-data-grid-pro";

export const StyledDataGrid = styled(DataGridPro)<{ colors: any }>(
  ({ theme, colors }) => ({
    "& .MuiDataGrid-root": {
      backgroundColor: "transparent",
      borderWidth: "0px !important",
      borderStyle: "none !important",
      borderColor: "none !important",
    },
    "& .MuiDataGrid-cell": {
      color: colors.text.muted,
      fontWeight: 400,
      minHeight: "3rem",
      fontSize: "1rem",
      fontFamily: "Roboto",
      lineHeight: "1.5rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      "&:focus, &:focus-within": {
        outline: "none",
      },
      padding: "1rem",
    },
    "& .MuiDataGrid-columnHeaders": {
      minHeight: "3rem",
      display: "flex",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: colors.background.accent,
      color: colors.text.primary,
      borderBottom: "none !important",
      "&:focus, &:focus-within": {
        outline: "none",
      },
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 500,
      lineHeight: "1.5rem",
      fontSize: "1rem",
      fontFamily: "Roboto",
    },
    "& .MuiDataGrid-columnHeaderTitleContainer": {
      borderBottom: "unset !important",
      display: "flex",
      justifyContent: "flex-start !important",
      alignItems: "center",
    },
    "& .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-footerContainer": {
      borderTop: "none !important",
    },
  })
);

